(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-featured-reviews';
  var CARD_SELECTOR = '.oddit-section-featured-reviews__card';
  var CLONE_ATTR = 'data-fr-clone';
  var sectionState = new Map();
  var sectionCounter = 0;

  // Strip reveal state from a cloned card so it renders immediately
  // (oddit-reveal would otherwise hold it at opacity:0) and never steals focus.
  // The oddit-hover-* classes are intentionally KEPT so clones lift on hover
  // like the originals — otherwise the duplicated edge cards look "dead".
  function sanitizeClone(el) {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute(CLONE_ATTR, 'true');
    var key = el.getAttribute('data-fr-clone-key') || 'c';
    var nodes = [el].concat(Array.prototype.slice.call(el.querySelectorAll('*')));
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.classList) {
        var tokens = Array.prototype.slice.call(n.classList);
        for (var j = 0; j < tokens.length; j++) {
          var c = tokens[j];
          if (c.indexOf('oddit-reveal') === 0) {
            n.classList.remove(c);
          }
        }
      }
      if (n.style) {
        n.style.opacity = '';
        n.style.transform = '';
        n.style.transition = '';
      }
      if (n.removeAttribute) {
        n.removeAttribute('data-oddit-stagger');
      }
      // Duplicate IDs on the curved-text <path> would be invalid; namespace
      // them per clone so each textPath still resolves to a real path.
      if (n.id) n.id = n.id + '-' + key;
      if (n.matches && n.matches('a, button, input, select, textarea, [tabindex]')) {
        n.setAttribute('tabindex', '-1');
      }
    }
    // Re-point textPath references to the renamed ids inside this clone.
    var textPaths = el.querySelectorAll('textPath');
    for (var t = 0; t < textPaths.length; t++) {
      var href = textPaths[t].getAttribute('href') || textPaths[t].getAttribute('xlink:href');
      if (href && href.charAt(0) === '#') {
        textPaths[t].setAttribute('href', href + '-' + key);
      }
    }
  }

  function initSection(section) {
    if (!section || section.dataset.odditFrInit === 'true') return;
    section.dataset.odditFrInit = 'true';

    var sectionKey = section.id || ('oddit-fr-' + (++sectionCounter));
    if (!section.id) section.id = sectionKey;

    var track = section.querySelector('[data-reviews-track]');
    if (!track) return;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll(CARD_SELECTOR + ':not([' + CLONE_ATTR + '])')
    );
    var N = originals.length;
    if (!N) return;
    var dots = section.querySelectorAll('.oddit-section-featured-reviews__dot');

    var loop = N > 1;

    var state = {
      currentIndex: 0,
      currentDomIndex: 0,
      slideCount: N,
      realStart: 0,
      autoplay: null,
      programmaticScroll: false,
      userControl: false,
      settleTimer: null,
      cleanup: []
    };

    // ---- Clone the full set on both sides for seamless infinite looping ----
    // Layout becomes [clones 0..N-1][originals 0..N-1][clones 0..N-1]; real
    // slides live at DOM indices [N, 2N). A clone immediately left of the first
    // real slide is the last slide and vice versa, so wrapping is invisible.
    if (loop) {
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();
      for (var c = 0; c < N; c++) {
        var before = originals[c].cloneNode(true);
        before.setAttribute('data-fr-clone-key', 'b' + c);
        sanitizeClone(before);
        beforeFrag.appendChild(before);
        var after = originals[c].cloneNode(true);
        after.setAttribute('data-fr-clone-key', 'a' + c);
        sanitizeClone(after);
        afterFrag.appendChild(after);
      }
      track.insertBefore(beforeFrag, originals[0]);
      track.appendChild(afterFrag);
      state.realStart = N;
    }

    var allSlides = track.querySelectorAll(CARD_SELECTOR);

    function getSlideOffset(domIndex) {
      var slide = allSlides[domIndex];
      if (!slide) return 0;
      // Center the slide within the viewport (symmetric bleed on both sides).
      return slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
    }

    function toLogical(domIndex) {
      return ((domIndex - state.realStart) % N + N) % N;
    }

    function nearestDomIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var closest = state.realStart;
      var closestDist = Infinity;
      for (var i = 0; i < allSlides.length; i++) {
        var slideCenter = allSlides[i].offsetLeft + allSlides[i].offsetWidth / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      }
      return closest;
    }

    function setScrollInstant(domIndex) {
      state.programmaticScroll = true;
      track.scrollTo({ left: getSlideOffset(domIndex), behavior: 'auto' });
      state.currentDomIndex = domIndex;
    }

    function smoothScrollToDom(domIndex) {
      state.programmaticScroll = true;
      state.currentDomIndex = domIndex;
      track.scrollTo({ left: getSlideOffset(domIndex), behavior: 'smooth' });
      updateDots(toLogical(domIndex));
    }

    function goToNext() { smoothScrollToDom(state.currentDomIndex + 1); }
    function goToLogical(j) { smoothScrollToDom(state.realStart + j); }
    function advanceSlide() { goToNext(); }

    function updateDots(index) {
      if (!dots || !dots.length) return;
      for (var i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('oddit-section-featured-reviews__dot--active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('oddit-section-featured-reviews__dot--active');
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    // If resting on a clone, jump by one full set to the equivalent real slide.
    // Clones are identical copies, so the jump is invisible.
    function normalizePosition() {
      if (!loop) { state.currentDomIndex = nearestDomIndex(); return false; }
      var dom = nearestDomIndex();
      if (dom < state.realStart) { setScrollInstant(dom + N); return true; }
      if (dom >= state.realStart + N) { setScrollInstant(dom - N); return true; }
      state.currentDomIndex = dom;
      return false;
    }

    function onScrollSettled() {
      var jumped = normalizePosition();
      state.currentIndex = toLogical(state.currentDomIndex);
      updateDots(state.currentIndex);
      state.programmaticScroll = jumped;
    }

    function scheduleSettle() {
      if (state.settleTimer) clearTimeout(state.settleTimer);
      state.settleTimer = setTimeout(onScrollSettled, 120);
    }

    function onScroll() {
      scheduleSettle();
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    state.cleanup.push(function () { track.removeEventListener('scroll', onScroll); });

    function onUserScrollIntent() {
      if (state.autoplay) state.autoplay.disableAutoplayPermanently();
    }
    track.addEventListener('wheel', onUserScrollIntent, { passive: true });
    state.cleanup.push(function () { track.removeEventListener('wheel', onUserScrollIntent); });

    // ---- Re-align to the current slide after a resize (widths change) ----
    var resizeTimer = null;
    function onResize() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setScrollInstant(state.currentDomIndex); }, 150);
    }
    window.addEventListener('resize', onResize);
    state.cleanup.push(function () {
      window.removeEventListener('resize', onResize);
      if (resizeTimer) clearTimeout(resizeTimer);
    });

    // ---- Mouse drag-to-scroll ----
    // Touch and trackpad already scroll the track natively, but a mouse has no
    // way to drag a horizontal overflow (a vertical wheel won't move it). Add
    // click-and-drag for mouse pointers only, so touch scrolling is untouched.
    // (PER-9 / PER-51 — "doesn't work with a mouse".)
    (function enableDragScroll() {
      var isDown = false;
      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var suppressNextClick = false;
      var DRAG_THRESHOLD = 5; // px of movement before a press becomes a drag

      function onPointerDown(e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        isDown = true;
        dragging = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      }

      function onPointerMove(e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          dragging = true;
          track.classList.add('is-dragging');
          if (state.autoplay) state.autoplay.disableAutoplayPermanently();
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        e.preventDefault();
        track.scrollLeft = startScroll - dx;
      }

      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        if (!dragging) return;
        dragging = false;
        suppressNextClick = true;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        // Settle on the nearest slide after a manual drag.
        smoothScrollToDom(nearestDomIndex());
      }

      // A drag ends with a synthetic click on whatever was under the cursor;
      // swallow it once so dragging the track never triggers a card link.
      function onClickCapture(e) {
        if (suppressNextClick) {
          suppressNextClick = false;
          e.preventDefault();
          e.stopPropagation();
        }
      }

      track.addEventListener('pointerdown', onPointerDown);
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', onClickCapture, true);

      state.cleanup.push(function () {
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', endDrag);
        track.removeEventListener('pointercancel', endDrag);
        track.removeEventListener('click', onClickCapture, true);
      });
    })();

    // ---- Autoplay (RAF-based) ----
    function initAutoplay() {
      var autoplayEnabled = section.dataset.autoplay === 'true';
      if (!autoplayEnabled || !loop) return null;

      var speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
      var intervalMs = speedSeconds * 1000;
      var rafId = null;
      var lastAdvance = performance.now();

      function disableAutoplayPermanently() {
        if (state.userControl) return;
        state.userControl = true;
        stopAutoplay();
      }

      function tick(now) {
        if (state.userControl) return;
        if (now - lastAdvance >= intervalMs) {
          advanceSlide();
          lastAdvance = now;
        }
        rafId = requestAnimationFrame(tick);
      }

      function startAutoplay() {
        if (state.userControl) return;
        if (rafId !== null) return;
        lastAdvance = performance.now();
        rafId = requestAnimationFrame(tick);
      }

      function stopAutoplay() {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotion.matches) {
        return {
          start: function () {},
          stop: function () {},
          destroy: function () {},
          disableAutoplayPermanently: function () {}
        };
      }

      function onVisibilityChange() {
        if (state.userControl) return;
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      }
      document.addEventListener('visibilitychange', onVisibilityChange);

      function onMouseEnter() { if (!state.userControl) stopAutoplay(); }
      function onMouseLeave() { if (!state.userControl) startAutoplay(); }
      track.addEventListener('mouseenter', onMouseEnter);
      track.addEventListener('mouseleave', onMouseLeave);

      track.addEventListener('focusin', disableAutoplayPermanently);
      track.addEventListener('touchstart', disableAutoplayPermanently, { passive: true });

      function onReducedMotionChange(e) {
        if (state.userControl) return;
        if (e.matches) stopAutoplay();
        else startAutoplay();
      }
      reducedMotion.addEventListener('change', onReducedMotionChange);

      startAutoplay();

      return {
        start: startAutoplay,
        stop: stopAutoplay,
        destroy: function () {
          stopAutoplay();
          document.removeEventListener('visibilitychange', onVisibilityChange);
          track.removeEventListener('mouseenter', onMouseEnter);
          track.removeEventListener('mouseleave', onMouseLeave);
          track.removeEventListener('focusin', disableAutoplayPermanently);
          track.removeEventListener('touchstart', disableAutoplayPermanently);
          reducedMotion.removeEventListener('change', onReducedMotionChange);
        },
        disableAutoplayPermanently: disableAutoplayPermanently
      };
    }

    // ---- Wire up dots ----
    if (dots && dots.length) {
      for (var d = 0; d < dots.length; d++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            var index = parseInt(dot.getAttribute('data-slide-index'), 10) || 0;
            goToLogical(index);
            if (state.autoplay) state.autoplay.disableAutoplayPermanently();
          });
        }(dots[d]));
      }
    }

    // ---- Initial state ----
    if (loop) setScrollInstant(state.realStart);
    state.currentIndex = 0;
    updateDots(0);

    state.autoplay = initAutoplay();
    sectionState.set(sectionKey, state);
  }

  function destroySection(section) {
    if (!section) return;
    var key = section.id;
    var state = sectionState.get(key);
    if (!state) return;
    if (state.autoplay) state.autoplay.destroy();
    for (var i = 0; i < state.cleanup.length; i++) {
      try { state.cleanup[i](); } catch (e) {}
    }
    if (state.settleTimer) clearTimeout(state.settleTimer);

    var track = section.querySelector('[data-reviews-track]');
    if (track) {
      var clones = track.querySelectorAll('[' + CLONE_ATTR + ']');
      for (var c = 0; c < clones.length; c++) {
        if (clones[c].parentNode) clones[c].parentNode.removeChild(clones[c]);
      }
    }

    sectionState.delete(key);
    section.dataset.odditFrInit = '';
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
